module.exports = __webpack_public_path__ + "static/media/email.9ad77e4f.svg";